import { render } from "./CustomizedSize.vue?vue&type=template&id=6d083f44"
import script from "./CustomizedSize.vue?vue&type=script&lang=js"
export * from "./CustomizedSize.vue?vue&type=script&lang=js"
script.render = render

export default script